import React from 'react';
import cn from 'clsx';

import { useDeviceType } from '@cian/ui-kit';

import styles from './styles.css';

interface IContainerInnerProps {
  children: React.ReactNode | null;
}

export const ContainerInner: React.FC<IContainerInnerProps> = props => {
  const { children } = props;
  const deviceType = useDeviceType();

  return <div className={cn(styles['content'], styles[deviceType])}>{children}</div>;
};
